export default "__VITE_ASSET__BLppROnS__"